export function startGrain(canvas: HTMLCanvasElement): () => void {
  const ctx = canvas.getContext('2d', { alpha: false });
  if (!ctx) return () => {};
  const width = 280;
  const height = 158;
  canvas.width = width;
  canvas.height = height;
  const image = ctx.createImageData(width, height);
  let raf: number | null = null;
  let stopped = false;
  let last = 0;

  const paint = (now: number) => {
    if (stopped) return;
    if (now - last > 78) {
      last = now;
      if (
        document.documentElement.dataset.graphics === 'low' ||
        document.documentElement.dataset.frameTarget === '30' ||
        document.hidden
      ) {
        raf = requestAnimationFrame(paint);
        return;
      }
      const data = image.data;
      for (let i = 0; i < data.length; i += 4) {
        const value = (Math.random() * 255) | 0;
        data[i] = value;
        data[i + 1] = value;
        data[i + 2] = value;
        data[i + 3] = 255;
      }
      ctx.putImageData(image, 0, 0);
    }
    raf = requestAnimationFrame(paint);
  };
  raf = requestAnimationFrame(paint);

  return () => {
    stopped = true;
    if (raf !== null) cancelAnimationFrame(raf);
  };
}

export function eyeMark(className = ''): string {
  return `
    <svg class="${className}" viewBox="0 0 120 72" aria-hidden="true" focusable="false">
      <path d="M5 36C20 10 38 2 60 2s40 8 55 34C100 62 82 70 60 70S20 62 5 36Z" fill="none" stroke="currentColor" stroke-width="2"/>
      <circle cx="60" cy="36" r="19" fill="none" stroke="currentColor" stroke-width="2"/>
      <circle cx="60" cy="36" r="7" fill="currentColor"/>
      <path d="M19 8 101 64" stroke="currentColor" stroke-width="3"/>
      <path d="M60 0v10M60 62v10M0 36h10M110 36h10" stroke="currentColor" stroke-width="1.5"/>
    </svg>`;
}
